import * as Etapas from './Etapas';
import * as Cliente from './Cliente';
import * as Gerencia from './Gerencia';
import * as Relatorios from './Relatorios';
import * as Catalogo from './Catalogo';

import { default as Home } from './Home';
import { default as FechamentoOS } from './FechamentoOS';
import { default as Orcamentos } from './Orcamentos';
import { default as Prospeccao } from './Prospeccao';
import { default as Projetos } from './Projetos';
import { default as FluxoProjetos } from './FluxoProjetos';
import { default as FluxoOrcamentos } from './FluxoOrcamentos';
import { default as CronogramaProjetos } from './CronogramaProjetos';
import { default as GestaoProjetos } from './GestaoProjetos';
import { default as AprovarOS } from './AprovarOS';
import { default as OrdemServico } from './OrdemServico';
import { default as OrdemServicoMod2 } from './OrdemServicoMod2';
import { default as Gantt } from './Gantt';
import { default as MapaAlocacao } from './MapaAlocacao';
import { default as PropostaComercial } from './PropostaComercial';
import { default as Gmud } from './Gmud';

export default {
  Home,
  Etapas,
  Cliente,
  Gerencia,
  FechamentoOS,
  Orcamentos,
  Prospeccao,
  Projetos,
  GestaoProjetos,
  AprovarOS,
  OrdemServico,
  OrdemServicoMod2,
  Gantt,
  Relatorios,
  Catalogo,
  FluxoProjetos,
  FluxoOrcamentos,
  PropostaComercial,
  CronogramaProjetos,
  MapaAlocacao,
  Gmud,
};
